import { Injectable } from '@angular/core';
import { HttpDataService } from '../../http/http-data.service';
import { INamedObject } from '../../../../type_definitions/datatypes';


@Injectable()
export class LedgerDataService {
  constructor(
    private httpDataService: HttpDataService
  ) {
    /**/
  }

  public getLedgers(): Promise<INamedObject[]> {
    return this.httpDataService.doGET(
      `rest/ledgers`,
      undefined,
      undefined,
      'Error loading ledgers'
    );
  }
}